export default {
  vehicleModel: "VehicleModel",
  AddVehicleModel: "AddVehicleModel",
  editVehicleModel: "EditVehicleModel",
};
